import { formatMessage as f } from '@/i18n';

export const getKeyStatus = () => {
  return [
    // 这里id取-1是因为要当在“全部”状态下要获取所有状态的钥匙，其他的id值是后台接口状态约定;
    { key: -1, name: f('key.status.all'), color: '' },
    { key: 0, name: f('key.status.normal'), color: '#8bc34a' },
    { key: 1, name: f('key.status.takeout'), color: '#2196f3' },
    { key: 2, name: f('key.status.damage'), color: '#ff5722' },
    { key: 3, name: f('key.status.lost'), color: '#ffc107' },
  ];
};

export const getKeyMode = () => {
  return [
    // color是来自ice的命名
    { key: -1, name: f('key.mode.all'), color: 'default' },
    { key: 0, name: f('key.mode.unlock'), color: 'primary' },
    { key: 1, name: f('key.mode.manage'), color: 'danger' },
    { key: 2, name: f('key.mode.patrol'), color: 'info' },
  ];
};

export const getGroup = () => {
  return [
    { key: 0, name: f('key.group.status') },
    { key: 1, name: f('key.group.mode') },
  ];
};

export const KEY_STATUS = {
  NORMAL: 0,
  OUT: 1,
  DAMAGED: 2,
  LOST: 3,
};

// 带指纹功能钥匙类型
export const fingerprint_keytypes = [2, 3, 6, 7, 9, 11];

// 带蓝牙功能钥匙类型
export const ble_keytypes = [1, 3, 5, 7, 10, 11];

// 带蜂窝(4G)功能钥匙类型
export const cellular_keytypes = [8, 9, 10, 11];

export const getKeyType = () => {
  return [
    { label: f('key.type.normal'), value: 0 },
    { label: f('key.type.ble'), value: 1 },
    { label: f('key.type.fingerprint'), value: 2 },
    { label: f('key.type.fingerprint_ble'), value: 3 },
    { label: f('key.type.normal_screen'), value: 4 },
    { label: f('key.type.ble_screen'), value: 5 },
    { label: f('key.type.fingerprint_screen'), value: 6 },
    { label: f('key.type.fingerprint_ble_screen'), value: 7 },
    { label: f('key.type.cellular_screen'), value: 8 },
    { label: f('key.type.fingerprint_cellular_screen'), value: 9 },
    { label: f('key.type.ble_cellular_screen'), value: 10 },
    { label: f('key.type.fingerprint_ble_cellular_screen'), value: 11 },
    { label: f('key.type.physical'), value: 12 },
  ];
};

export const getAuthStatus = () => {
  return [
    // 这里id取-1是因为要当在“全部”状态下要获取所有状态的钥匙，其他的id值是后台接口状态约定;
    {
      value: 0,
      label: f('key.connector.authority.authstatus.unauthorized'),
      color: '#ffc107',
      type: 'secondary',
      shape: '',
    },
    {
      value: 1,
      label: f('key.connector.authority.authstatus.authorized'),
      color: '#8bc34a',
      type: 'primary',
      shape: '',
    },
    {
      value: 2,
      label: f('key.connector.authority.authstatus.expired'),
      color: '#ff5722',
      type: 'primary',
      shape: 'warning',
    },
    {
      value: 3,
      label: f('key.connector.authority.authstatus.expiration'),
      color: '#ff5722',
      type: 'primary',
      shape: 'warning',
    },
  ];
};
